import { DocumentoAllegato } from '../documento-allegato';
import { IstanzaAssegnazione } from '../immobili/istanza-assegnazione';
import { IstanzaVendita } from '../immobili/istanza-vendita';
import { Ubicazione } from '../immobili/ubicazione';
import { TipoDirittoReale } from '../tipologiche/tipo-diritto-reale';
import { TipoGenericoRimovibile } from '../tipologiche/tipo-generico-rimovibile';

export class BeneMobile {
  id: string;
  tipoBeneMobile: TipoGenericoRimovibile;
  descrizione: string;
  ubicazione: Ubicazione;
  valore: number | string;
  valoreIpoteca: number | string;
  sommaBloccata: number | string;
  dataBloccoSomma: number;
  sommaSvincolata: number | string;
  dataSvincoloSomma:  number;
  ipoteca: boolean;
  quantita: number;
  riferimentoInventario: string;
  dataInventario: number;
  istanzaVendita: IstanzaVendita;
  istanzaAssegnazione: IstanzaAssegnazione;
  note: string;
  unitaMisura: string;
  documenti: DocumentoAllegato[];
  quota: any;
  tipoDirittoReale: TipoDirittoReale;
  dataRichiestaNotifica?: number;
  dataNotifica?: number;
  terzo?: string;
  pignorato?: boolean;
}
